import { createConsumer } from '@rails/actioncable';
import './signature_channel';
import './subscription_intention_channel';
import './export_operations_channel';
import './distributors_exports_channel';

export default createConsumer();
